import { CommonModule, DatePipe } from '@angular/common'
import { Component } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { DateInputCustomFormatPlaceholder, DatePickerComponent } from '@progress/kendo-angular-dateinputs'
import { KENDO_DROPDOWNLIST, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { CheckBoxDirective, KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { LabelDirective } from '@progress/kendo-angular-label'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { Utilities } from '../../../../utilities/utilities'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'

@Component({
  selector: 'gd-type-editor-crd-branch',
  templateUrl: './type-editor-crd-branch.component.html',
  styleUrls: ['./type-editor-crd-branch.component.scss'],
  imports: [
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_BUTTONS,
    CommonModule,
    GridComponent,
    DataBindingDirective,
    ToolbarTemplateDirective,
    GridToolbarFocusableDirective,
    AddCommandDirective,
    LabelDirective,
    FormsModule,
    CheckBoxDirective,
    ColumnComponent,
    EditTemplateDirective,
    ReactiveFormsModule,
    KENDO_DROPDOWNLIST,
    CellTemplateDirective,
    DatePickerComponent,
    CommandColumnComponent,
    FocusableDirective,
    EditCommandDirective,
    SaveCommandDirective,
    CancelCommandDirective,
    DatePipe,
  ]
})
export class TypeEditorCrdBranchComponent extends GridEditorBaseComponent {
  activeCrdBranchTypes = this.repState.getActiveCrdBranchTypes()
  activeBanks = this.repState.getActiveBanks()
  activeBrokerFirms = this.repState.getActiveBrokerFirms()
  activeBranches = this.repState.getActiveBranches()
  activeOfficeTypes = this.repState.getActiveOfficeTypes()
  activeRegions = this.repState.getActiveRegions()
  public checked = false
  private cnt = 0
  public asDateInput = (value) =>
    Utilities.asType<DateInputCustomFormatPlaceholder>(value)

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  initGrid(): void {
    this.typesService.getCRDBranch().subscribe((response) => {
      this.repState.crdBranches = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const crdBranch = formGroup.value
    this.typesService.submitCRDBranchUpdate(crdBranch).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        crdBranchNumber: null,
        crdBranchName: null,
        crdBranchTypeID: null,
        startDate: null,
        endDate: null,
        personInCharge: null,
        privateRes: null,
        sharedOffice: null,
        bankID: null,
        officeTypeID: null,
        branchCode: null,
        officeRegion: null,
        officeDBAName: null,
        designatedSupervisor: null,
        brokerFIrmID: null,
        crdBranchTypeName: null,
        bankName: null,
        officeTypeName: null,
        brokerFirmName: null,
        branchDescription: null,
        officeRegionName: null,
        isNew: true,
      },
    )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(crdBranch: any): UntypedFormGroup {
    return this.formBuilder.group({
      crdBranchNumber: [crdBranch.crdBranchNumber, Validators.required],
      crdBranchName: crdBranch.crdBranchName,
      crdBranchTypeID: crdBranch.crdBranchTypeID,
      startDate: [
        crdBranch.startDate ? new Date(crdBranch.startDate) : null,
        Validators.required,
      ],
      endDate: crdBranch.endDate ? new Date(crdBranch.endDate) : null,
      personInCharge: crdBranch.personInCharge,
      privateRes: crdBranch.privateRes,
      sharedOffice: crdBranch.sharedOffice,
      bankID: crdBranch.bankID,
      officeTypeID: crdBranch.officeTypeID,
      branchCode: crdBranch.branchCode,
      officeRegion: crdBranch.officeRegion,
      officeDBAName: crdBranch.officeDBAName,
      designatedSupervisor: crdBranch.designatedSupervisor,
      brokerFirmID: crdBranch.brokerFirmID,
      crdBranchTypeName: crdBranch.crdBranchTypeName,
      bankName: crdBranch.bankName,
      officeTypeName: crdBranch.officeTypeName,
      brokerFirmName: crdBranch.brokerFirmName,
      branchDescription: crdBranch.branchDescription,
      officeRegionName: crdBranch.officeRegionName,
      isNew: crdBranch.isNew,
    })
  }
  toggleViewRefresh() {
    this.initGrid()
    this.checked = false
    return
  }
  toggleViewActive(e: boolean) {
    if (this.cnt === 0) {
      const filteredData = this.repState.crdBranches.filter(
        (x) => x.endDate !== null,
      )
      this.repState.crdBranches = filteredData
      this.cnt++
      this.checked = true
      return
    }
    if (this.cnt === 1) {
      this.initGrid()
      this.cnt++
      this.checked = false
      return
    }
    if (e === false) {
      const filteredData = this.repState.crdBranches.filter(
        (x) => x.endDate !== null,
      )
      this.repState.crdBranches = filteredData
      this.checked = false
      return
    }
    if (e === true) {
      this.checked = true
      this.initGrid()
      return
    }
  }
}
